import React from 'react';

import { MeasurementFieldType, powerConverter, TPowerUnit } from 'models';
import { IntlHelpers } from 'helpers/IntlHelpers';

import type { MeasurementInputWrapperProps } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { MeasurementInputWrapper } from 'components/forms/fields/measurement/MeasurementInputWrapper';
import { UnitWithTooltip } from 'components/forms/fields/measurement/Unit';
import { useMultiUnitMeasurementController } from 'components/forms/fields/measurement/useMultiUnitMeasurementController';
import { useRenderVariableMultiInput } from 'components/forms/fields/measurement/useRenderVariableMultiInput';

type PowerFieldProps = {
    name: string;
    fields?: MeasurementFieldType[];
    hideIcons?: boolean;
    placeholder?: string | number;
    defaultUnit?: TPowerUnit;
} & Omit<MeasurementInputWrapperProps, 'placeholder'>;

const PowerField = ({
    name,
    fields = ['nom', 'max'],
    hideIcons,
    placeholder,
    defaultUnit,
    ...wrapperProps
}: PowerFieldProps) => {
    const {
        unit,
        cycleUnit,
        convertValue,
        fields: fieldsRecord,
    } = useMultiUnitMeasurementController({
        name,
        converter: powerConverter,
        defaultUnit,
        fields,
    });

    const extraProps = {
        hideIcon: hideIcons,
        size: wrapperProps.size,
    };

    if (placeholder) {
        // @ts-ignore
        extraProps.placeholder =
            typeof placeholder === 'number' ? IntlHelpers.formatNumber(Number(convertValue(placeholder))) : placeholder;
    }

    const Unit = <UnitWithTooltip onClick={cycleUnit}>{unit}</UnitWithTooltip>;
    const Fields = useRenderVariableMultiInput({
        fields,
        fieldsRecord,
        Unit,
        extraProps,
    });

    return <MeasurementInputWrapper {...wrapperProps}>{Fields}</MeasurementInputWrapper>;
};

export { PowerField };
